import { BaseService } from "../../core/baseService";
import { ApiResult } from "../../core/types";
import {
  TranslateContentRequest,
  TranslateAllRequest,
  TranslationPreviewResponse,
  TranslationServiceInterface,
} from "../types/translation.types";

export class TranslationService
  extends BaseService
  implements TranslationServiceInterface
{
  async previewTranslations(
    request: TranslateContentRequest
  ): Promise<ApiResult<TranslationPreviewResponse>> {
    return this.handleRequest<TranslationPreviewResponse>(
      this.client.post("/api/admin/translations/preview", request)
    );
  }

  async translateToAllLanguages(
    request: TranslateAllRequest
  ): Promise<ApiResult<TranslationPreviewResponse>> {
    return this.handleRequest<TranslationPreviewResponse>(
      this.client.post("/api/admin/translations/translate-all", request)
    );
  }
}
